import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { trackPageView } from '../telemetry';
import { routes } from '../App.routing';

/**
 * Invisible component that fires an Application Insights `trackPageView`
 * every time the React Router location changes.
 *
 * Place this inside `<BrowserRouter>` so it has access to location context.
 */
const TelemetryTracker = () => {
    const location = useLocation();
    const prevPathRef = useRef<string | null>(null);

    useEffect(() => {
        // Avoid duplicate tracking for the same path
        if (location.pathname === prevPathRef.current) return;
        prevPathRef.current = location.pathname;

        // Try to resolve a friendly route name from the defined routes
        const matchedRoute = routes.find((r) => {
            // Convert route pattern "/clients/:clientId/*" → regex
            const pattern = r.path
                .replace(/:[^/]+/g, '[^/]+') // :param → wildcard segment
                .replace(/\*/g, '.*');         // * → match rest
            return new RegExp(`^${pattern}$`).test(location.pathname);
        });

        const pageName = matchedRoute?.name ?? location.pathname;
        trackPageView(pageName, location.pathname + location.search);
    }, [location]);

    return null; // renders nothing
};

export default TelemetryTracker;
